import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import defaultImage from '../images/gauti-selvaraj.png';
import { withPrefix } from 'gatsby-link';

const defaultTitle =
  'Gowtham Selvaraj (Gauti) - Full Stack JavaScript Engineer';
const defaultDescription =
  "I'm Gowtham Selvaraj (Gauti), a Full Stack JavaScript Engineer based in Christchurch, New Zealand.";
const defaultUrl = 'https://www.gauti.info';

const HelmetWrapper = ({ title, description, image, path }) => {
  const url = `${defaultUrl}${path}`;
  const absoluteImage = `${defaultUrl}${image}`;

  return (
    <Helmet>
      <html lang="en" />
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta name="viewport" content="width=device-width, initial-scale = 1.0" />
      <link rel="canonical" href={url} />

      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${defaultUrl}${withPrefix('/apple-touch-icon.png')}`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`${defaultUrl}${withPrefix('/icon-32x32.png')}`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`${defaultUrl}${withPrefix('/icon-16x16.png')}`}
      />
      <link
        rel="manifest"
        href={`${defaultUrl}${withPrefix('/manifest.webmanifest')}`}
      />
      <meta name="msapplication-TileColor" content="#272727" />
      <meta name="theme-color" content="#272727" />

      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={absoluteImage} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImage} />
    </Helmet>
  );
};

HelmetWrapper.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  path: PropTypes.string
};

HelmetWrapper.defaultProps = {
  title: defaultTitle,
  description: defaultDescription,
  image: defaultImage,
  path: ''
};

export default HelmetWrapper;



// WEBPACK FOOTER //
// ./src/components/Helmet.js